/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

// jscs:disable maximumLineLength
'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var ShareTools = (function (_Component) {
	_inherits(ShareTools, _Component);

	function ShareTools() {
		_classCallCheck(this, ShareTools);

		_Component.apply(this, arguments);
	}

	ShareTools.prototype.render = function render() {
		var _classNames;

		var styles = require('./ShareTools.css');
		var _props = this.props;
		var layout = _props.layout;
		var url = _props.url;
		var title = _props.title;
		var className = _props.className;

		var baseClasses = _classnames2['default']((_classNames = {}, _classNames[styles.Base] = true, _classNames[styles['Base--' + layout]] = true, _classNames[className] = className, _classNames));

		return _react2['default'].createElement(
			'ul',
			{ className: baseClasses },
			_react2['default'].createElement(
				'li',
				{ className: styles.Item },
				_react2['default'].createElement(
					'a',
					{ className: styles['Link--facebook'], href: 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url) },
					'Share on Facebook'
				)
			),
			_react2['default'].createElement(
				'li',
				{ className: styles.Item },
				_react2['default'].createElement(
					'a',
					{ className: styles['Link--twitter'], href: 'https://twitter.com/home?status=' + encodeURIComponent(title) + '%20%E2%80%94%20on%20%40BaltimoreBrew%20' + encodeURIComponent(url) },
					'Share on Twitter'
				)
			),
			_react2['default'].createElement(
				'li',
				{ className: styles.Item },
				_react2['default'].createElement(
					'a',
					{ className: styles['Link--email'], href: 'mailto:?&subject=' + encodeURIComponent(title) + '&body=Check%20out%20this%20article%20at%20BaltimoreBrew.com%3A%20' + encodeURIComponent(url) },
					'Email this article'
				)
			),
			_react2['default'].createElement(
				'li',
				{ className: styles.Item },
				_react2['default'].createElement(
					'a',
					{ className: styles['Link--print'], href: '#', onClick: function (event) {
							event.preventDefault();
							window.print();
						} },
					'Print this article'
				)
			)
		);
	};

	_createClass(ShareTools, null, [{
		key: 'propTypes',
		value: {
			className: _react.PropTypes.string,
			url: _react.PropTypes.string,
			title: _react.PropTypes.string,
			layout: _react.PropTypes.string
		},
		enumerable: true
	}, {
		key: 'defaultProps',
		value: {
			layout: 'vertical'
		},
		enumerable: true
	}]);

	return ShareTools;
})(_react.Component);

exports['default'] = ShareTools;
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ShareTools/ShareTools.js
 ** module id = 692
 ** module chunks = 0
 **/